import { Component, effect, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';

import { AppErrorCodes } from '@core/api';
import { IconService } from '@core/common';
import { errorActions, errorSelectors, initActions } from '@core/store';
import { ActionErrorComponent, AppPageErrorComponent } from '@shared/errors';

@Component({
  selector: 'la-root',
  template: `
    @if (pageError(); as error) {
      <la-app-page-error [error]="error" (recover)="clearPageError()"></la-app-page-error>
    } @else {
      <router-outlet></router-outlet>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, AppPageErrorComponent],
})
export class AppComponent implements OnInit {
  private store = inject(Store);
  private icons = inject(IconService);
  private dialog = inject(MatDialog);

  readonly pageError = this.store.selectSignal(errorSelectors.getPageError);
  readonly actionError = this.store.selectSignal(errorSelectors.getActionError);

  readonly errorCodes = AppErrorCodes;

  constructor() {
    effect(() => {
      const actionError = this.actionError();
      if (actionError) {
        this.dialog
          .open(ActionErrorComponent, { data: actionError })
          .afterClosed()
          .subscribe(() => this.store.dispatch(errorActions.clearError()));
      }
    });
  }

  ngOnInit() {
    this.store.dispatch(initActions.appInit());
    this.icons.install();
  }

  clearPageError() {
    this.store.dispatch(errorActions.clearError());
  }
}
